export const accessKeys = {
  license: "LIC",
  userLicense: "USR",
  sms: "SMS",
  iframe: "IFRAME",
  eportAssist: "APP",
  courseAdmin: "ICA",
  report: "REPORT",
  actorPermit: "PERMITS",
  licenseRegistration: "LICENSE_REG",
  instructorMaterial: "INST_MAT",
  freePackage: "FREE",
  standardPackage: "STD",
  advancedPackage: "ADV",
  dashboard: "DASH",
  swedishCompany: "SWE",
  norwegianCompany: "NOR",
  frenchCompany: "FRA",
  englishCompany: "ENG",
  germanCompany: "GER",
  isMASystem: "LUND",
  licenseIssuer: "LIC_ISS",
  admin: "ADMIN",
  digitalLicenses: "DLIC",
  digitalLicensesHolder: "DLH",
  digitalLicensesContact: "DLC",
  digitalLicensesPublic: "DLP",
  actorPermitSignHolder: "APH", // This is when a holder signs in to permit sign
  actorPermitSignResponsible: "APR", // This is when a responsible signs in to permit sign
  actorPermitResponsibleViewAdmin: "APRV_ADM", // This is when a real user signs in to ePort, i.e. not to the responsible view
  actorPermitResponsibleView: "APRV", // This is for when a responsible signs in to the responsible view (they don't have a real user)
  actorPermitBrokerSource: "APBS", // This is for when a broker is signed in on a non-broker user, from which they can export data
};

let parsedUserAccess;
function getUserAccess() {
  if (!parsedUserAccess && sessionStorage.userAccess) {
    parsedUserAccess = new Set(JSON.parse(sessionStorage.userAccess));
  }
  return parsedUserAccess ?? new Set();
}

export function hasSomeAccess(...accesses) {
  const userAccess = getUserAccess();
  return accesses.some((access) => userAccess.has(access));
}

export function hasAccess(...accesses) {
  const userAccess = getUserAccess();
  return accesses.every((access) => userAccess.has(access));
}

export function setAccess(accessCollection) {
  console.log("setAccess")
  sessionStorage.setItem("userAccess", JSON.stringify(accessCollection));
}

export function resetAccess() {
  console.log("resetAccess")
  parsedUserAccess = null;
  sessionStorage.removeItem("userAccess");
}

export const refreshTokenExpirationMinutes = 60;
